export default function (translations, number) {
  const CASES_PLURAL_NUMBERS = [2, 0, 1, 1, 1, 2]

  return translations[(number % 100 > 4 && number % 100 < 20) ? 2 : CASES_PLURAL_NUMBERS[(number % 10 < 5) ? number % 10 : 5]]
}
